/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploadingimages1Inputs */

const en_uploadingimages1 = /** @type {(inputs: Uploadingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading Images...`)
};

const de_uploadingimages1 = /** @type {(inputs: Uploadingimages1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder werden hochgeladen…`)
};

/**
* | output |
* | --- |
* | "Uploading Images..." |
*
* @param {Uploadingimages1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const uploadingimages1 = /** @type {((inputs?: Uploadingimages1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadingimages1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadingimages1(inputs)
	return de_uploadingimages1(inputs)
});
export { uploadingimages1 as "uploadingImages" }